/**
 * Generate a new Shifty API key (client-side; store only in Firestore for tenant integrations).
 * @returns {string}
 */
export function generateShiftyApiKey() {
  const suffix = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID().replace(/-/g, '')
    : `${Date.now()}${Math.random().toString(36).slice(2)}`;
  return `shifty_${suffix}`;
}

/**
 * Mask a key for display (e.g. shifty_abc123************wxyz).
 * @param {string} key
 * @returns {string}
 */
export function maskApiKey(key) {
  if (!key || typeof key !== 'string') return 'shifty_***';
  if (key.length <= 12) return 'shifty_***';
  const prefix = key.startsWith('shifty_') ? key.slice(0, 12) : key.slice(0, 8);
  const tail = key.slice(-4);
  return `${prefix}${'*'.repeat(8)}${tail}`;
}

/**
 * @param {import('firebase/firestore').Timestamp | Date | string | null | undefined} value
 * @returns {string}
 */
export function formatApiKeyDate(value) {
  if (!value) return '—';
  if (typeof value.toDate === 'function') {
    return value.toDate().toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
}
